<script lang="ts" setup>
  import useOuraAuth from '#web-oura-tools/auth'

  import { useAppStore } from '#ourahub-intra/stores/application'
  import { useServicesStore } from '#ourahub-intra/stores/services'

  const ouraAuth = useOuraAuth()

  const ouraHubStore = useAppStore()
  const servicesStore = useServicesStore()
</script>

<template lang="html">
  <v-app v-if="ouraAuth.user.value && !ouraHubStore.isLoading">
    <UpdatesBanner :services="servicesStore.servicesList" />

    <ServicesCatalog :user="ouraAuth.user.value" :services="servicesStore.servicesList" />
  </v-app>
</template>
